import type { PlanFeature } from "../types/billing";

/**
 * Which plan feature a route needs. Free users can open everything else (Dashboard, Trade Log,
 * Workspace, Strategy R&D, University, account settings); these show a holding screen instead.
 * The backend enforces the same features on its endpoints.
 */
const ROUTE_FEATURES: ReadonlyArray<{ prefix: string; feature: PlanFeature }> = [
  { prefix: "/statistics", feature: "statistics" },
  { prefix: "/reports", feature: "reports" },
  { prefix: "/simulator", feature: "reports" },
  { prefix: "/execution-rules-simulator", feature: "reports" },
  { prefix: "/backtests", feature: "reports" },
  { prefix: "/strategies", feature: "reports" },
  { prefix: "/workspace/strategy", feature: "reports" },
  { prefix: "/launchpad", feature: "launchpad" },
  { prefix: "/live-strategies", feature: "launchpad" },
];

export function featureForPath(pathname: string): PlanFeature | null {
  const path = pathname.replace(/\/+$/, "") || "/";
  for (const { prefix, feature } of ROUTE_FEATURES) {
    if (path === prefix || path.startsWith(`${prefix}/`)) return feature;
  }
  return null;
}

export const FEATURE_COPY: Record<PlanFeature, { title: string; body: string }> = {
  statistics: {
    title: "Statistics",
    body: "Break your trading down by session, symbol, setup and time, across your full history.",
  },
  reports: {
    title: "Reports & simulations",
    body: "Generate reports on your trades and simulate how different rules would have changed the result.",
  },
  workspace: {
    title: "Workspace",
    body: "Build reports, simulations and strategies side by side on one canvas.",
  },
  launchpad: {
    title: "Launchpad",
    body: "Run your strategies on paper or on your broker account, with Co-pilot approvals or full Autopilot.",
  },
  pine: {
    title: "Pine Script export",
    body: "Export any backtested strategy as a TradingView Pine Script.",
  },
};
